module.exports = require("./khq.d.ts");